import classes from "./Cards.module.css";
import { useState } from "react";
import Backdrop from "../BackDrop/BackDrop";
import PrizeForm from "../AddPrizeForm/AddPrizeForm";
import ObjectiveForm from "../AddObjectiveForm/AddObjectiveForm";
import React from "react";
import { useTranslation } from "react-i18next";
import { Form, useNavigate } from "react-router-dom";
import serverPostData from "../../utils/ServerPostData";
import GreenBearLogo from "../../images/logo/GreenBearLogo.png";
import { QRCode } from "react-qrcode-logo";
import html2canvas from "html2canvas";
// import MaterialIcon from "react-google-material-icons";
import { lightModeColors, darkModeColors } from "../../utils/colors";
import { useContext } from "react";
import DarkModeContext from "../../store/DarkModeContext";
import { MdOutlineAddTask } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { toast } from 'react-toastify';

//===============================================================================================================
//======================================== ADD CARDS COMPONENT ==================================================
//===============================================================================================================
export function AddPrizeCard(props) {
  const navigate = useNavigate();
  const [prizeFormIsOpen, setPrizeFormIsOpen] = useState(false);
  const [tg, i18] = useTranslation("global");

  function backdropHandlerActivate() {
    setPrizeFormIsOpen(true);
  }

  function backdropHandlerDeactivate() {
    setPrizeFormIsOpen(false);
  }
  function backdropHandlerDeactivateRefresh() {
    setPrizeFormIsOpen(false);
    navigate("/prize");
  }

  return (
    <div>
      <div className={classes.header}>
        <h1
          style={{
            display: "inline-block",
            marginRight: "20px",
            fontSize: "30px",
          }}
        >
          {tg("global.header.prizes")}
        </h1>
        <button className={classes.addNew} onClick={backdropHandlerActivate}>
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* <MaterialIcon
              icon="add_task"
              size={25}
              color="White"
              style={{ position: "relative" }}
              zIndex="0"
            /> */}
            <MdOutlineAddTask size={25} color="white" />
            
            <span style={{ marginLeft: "10px", fontSize: "20px" }}>
              {tg("prizes.add.new_prize")}
            </span>
          </div>
        </button>
      </div>

      {prizeFormIsOpen && (
        <PrizeForm
          cancel={backdropHandlerDeactivate}
          confirm={backdropHandlerDeactivateRefresh}
        />
      )}
      {/* prizeform always true, then prizeform handler renders it or not */}
      {prizeFormIsOpen ? <Backdrop cancel={backdropHandlerDeactivate} /> : null}
    </div>
  );
}

export function AddObjectiveCard(props) {
  const [objectiveFormIsOpen, setObjectiveFormIsOpen] = useState(false);
  const [tg, i18] = useTranslation("global");

  function backdropHandlerActivate() {
    setObjectiveFormIsOpen(true);
  }

  function backdropHandlerDeactivate() {
    setObjectiveFormIsOpen(false);
  }

  return (
    <div>
      <div className={classes.header}>
        <h1
          style={{
            display: "inline-block",
            marginRight: "20px",
            fontSize: "30px",
          }}
        >
          {tg("global.header.objectives")}
        </h1>
        <button className={classes.addNew} onClick={backdropHandlerActivate}>
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* <MaterialIcon
              icon="add_task"
              size={25}
              color="White"
              style={{ position: "relative" }}
            /> */}
            <MdOutlineAddTask size={25} color="white" />
            <span style={{ marginLeft: "10px", fontSize: "20px" }}>
              {tg("objectives.add.new_objective")}
            </span>
          </div>
        </button>
      </div>

      {objectiveFormIsOpen && (
        <ObjectiveForm
          cancel={backdropHandlerDeactivate}
          confirm={backdropHandlerDeactivate}
        />
      )}
      {/* prizeform always true, then prizeform handler renders it or not */}
      {objectiveFormIsOpen ? (
        <Backdrop cancel={backdropHandlerDeactivate} />
      ) : null}
    </div>
  );
}

//===============================================================================================================
//==================================== EDIT/DELETE CARDS COMPONENT ==============================================
//===============================================================================================================

export function Delete(props) {
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [tg, i18] = useTranslation("global");

  function backdropHandlerActivate() {
    setDeleteModalIsOpen(true);
  }

  function backdropHandlerCancel() {
    setDeleteModalIsOpen(false);
    console.log(props.id);
    console.log("delete canceled");
  }
  function backdropHandlerConfirm() {
    const formData = new FormData();
    setDeleteModalIsOpen(false);
    console.log(props.id);
    console.log("delete confirmed");
    formData.append("id", props.id);

    const serverResponse = serverPostData("/dashboard-delete-prize", formData);
    serverResponse.then((response) => {
      let data = response;

      if (data.status === 200) {
        alert(tg("global.general.success"));
        window.location.reload();
      } else {
        alert(tg("global.general.error"));
      }
    });
  }


  

  return (
    <span>
      <button className={classes.delete} onClick={backdropHandlerActivate}>
        <MdDelete size={40} color="black" />
        {/* <MaterialIcon icon="delete" size={40} color="White" style={{position:"relative", zIndex:"1"}} /> */}
      </button>
      {deleteModalIsOpen && (
        <DeleteForm
          cancel={backdropHandlerCancel}
          confirm={backdropHandlerConfirm}
        />
      )}
      {/* prizeform always true, then prizeform handler renders it or not */}
      {deleteModalIsOpen ? <Backdrop cancel={backdropHandlerCancel} /> : null}
    </span>
  );
}



export function DeleteObjective(props) {
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [tg, i18] = useTranslation("global");

  function backdropHandlerActivate() {
    setDeleteModalIsOpen(true);
  }

  function backdropHandlerCancel() {
    setDeleteModalIsOpen(false);
    console.log(props.id);
    console.log("delete canceled");
  }
  function backdropHandlerConfirm() {
    const formData = new FormData();
    setDeleteModalIsOpen(false);
    console.log(props.id);
    console.log("delete confirmed");
    formData.append("id", props.id);

    const serverResponse = serverPostData("/dashboard-delete-objective", formData);
    serverResponse.then((response) => {
      let data = response;

      if (data.status === 200) {
        alert(tg("global.general.success"));
        window.location.reload();
      } else {
        alert(tg("global.general.error"));
      }
    });
  }


  

  return (
    <span>
      <button className={classes.delete} onClick={backdropHandlerActivate}>
        <MdDelete size={40} color="black" />
        {/* <MaterialIcon icon="delete" size={40} color="White" style={{position:"relative", zIndex:"1"}} /> */}
      </button>
      {deleteModalIsOpen && (
        <DeleteForm
          cancel={backdropHandlerCancel}
          confirm={backdropHandlerConfirm}
        />
      )}
      {/* prizeform always true, then prizeform handler renders it or not */}
      {deleteModalIsOpen ? <Backdrop cancel={backdropHandlerCancel} /> : null}
    </span>
  );
}

export function DeleteForm(props) {
  const [tg, i18] = useTranslation("global");

  return (
    <div className={classes.deleteForm}>
      <form>
        <h2>{tg("global.general.sureDelete")}</h2>
        <button className={classes.cancel_button} onClick={props.cancel}>
          {tg("global.general.cancel")}
        </button>
        <button className={classes.submit_button} onClick={props.confirm}>
          {tg("global.general.confirm")}
        </button>
      </form>
    </div>
  );
}


export function AddForm(props) {
  const [tg, i18] = useTranslation("global");

  return (
    <div className={classes.deleteForm}>
      <form>
        <h2>{tg("global.general.sureAdd")}</h2>
        <button className={classes.cancel_button} onClick={props.cancel}>
          {tg("global.general.cancel")}
        </button>
        <button className={classes.submit_button} onClick={props.confirm}>
          {tg("global.general.confirm")}
        </button>
      </form>
    </div>
  );
}

//===============================================================================================================
//======================================== PRIZE CARDS COMPONENT =================================================
//===============================================================================================================

export function PrizeCard(props) {
  const [tg, i18] = useTranslation("global");

  function editButton() {
    console.log(props.id);
  }
  const walletTranslations = {
    schoolWallet: tg("global.wallet.walletSchool"),
    councilWallet: tg("global.wallet.walletCouncil"),
  };
  const { darkMode } = useContext(DarkModeContext);
  const { textColor, backgroundColor, cardColor } = darkMode
    ? darkModeColors
    : lightModeColors;

  return (
    <div className={classes.card} style={{ "--card-color": cardColor }}>
      <img src={props.image} alt={props.title} className={classes.img} />

      <div className={classes.buttons}>
        <button className={classes.edit} onClick={editButton}>
          <img
            src={require("../../images/miscellaneous/pencil.png")}
            alt="dark mode toggle"
            width="25px"
          />
        </button>

        <Delete id={props.id} image={props.image} />
      </div>
      <h2 className={classes.title}>{props.title}</h2>
      <h2 className={classes.pointValue}>
        <div className={classes.noSpace}>
          {tg("global.wallet.wallet")}{" "}
          {walletTranslations[props.wallet] || props.wallet}
        </div>
        {tg("prizes.card.price")} {props.pointValue} {tg("prizes.card.points")}
      </h2>
      <p className={classes.description}>{props.description}</p>
      <h2 className={classes.pointValue}>
        {tg("prizes.card.availability")} {props.availability} <br />{" "}
        {tg("prizes.card.maxPerUser")} {props.maxPerUser}
      </h2>
      <h5 className={classes.dueDate}>
        {tg("prizes.card.valid_until")} {props.dueDate}
      </h5>
    </div>
  );
}

/*<div className={classes.buttons}>
      <button className={classes.more}> {tg("prizes.card.more")} </button>

      <button className={classes.edit} onClick={editButton}>
      <img
            src={require(
              "../../images/miscellaneous/pencil.png")}
            alt="dark mode toggle"
            width="25px"
          />
      </button>        

     <Delete id = {props.id} image= {props.image}/>
      </div>*/

//===============================================================================================================
//======================================== OBJECTIVE CARDS COMPONENT ============================================
//===============================================================================================================

export function ObjectiveCard(props) {
  const [tg, i18] = useTranslation("global");

  function editButton() {
    console.log(props.id);
  }

  function downloadQRCode(qrCodeId) {

    const qrCodeDiv = document.getElementById(qrCodeId);
    console.log(qrCodeId);

    html2canvas(qrCodeDiv).then(function (canvas) {
      const qrCodeImage = canvas.toDataURL("image/png");

      const downloadLink = document.createElement("a");
      downloadLink.href = qrCodeImage;
      downloadLink.download = "qr_code.png";
      downloadLink.click();
    });
  }
  const walletTranslations = {
    schoolWallet: tg("global.wallet.walletSchool"),
    councilWallet: tg("global.wallet.walletCouncil"),
    marketWallet: tg("global.wallet.walletMarket"),
  };
  const { darkMode } = useContext(DarkModeContext);
  const { textColor, backgroundColor, cardColor } = darkMode
    ? darkModeColors
    : lightModeColors;

  const [showQR, setShowQR] = useState(false);

  function setShowqr() {
    setShowQR(true);
  }

  function backdropHandlerCancel() {
    setShowQR(false);
  }

  return (
    <div className={classes.ocard} style={{ "--card-color": cardColor }}>
      <h2 className={classes.title}>{props.title}</h2>

      <h2 className={classes.noSpace}>
        {tg("objectives.card.price")} {props.pointValue}{" "}
        {tg("objectives.card.points")}
      </h2>
      <h2 className={classes.noSpace}>
        {tg("global.wallet.wallet")}{" "}
        {walletTranslations[props.wallet] || props.wallet}
      </h2>
      <h2 className={classes.noSpace}>
        {tg("objectives.card.repCounter")} {props.repCounter}
      </h2>
      <h2 className={classes.noSpace}>
        {tg("objectives.card.refreshRate")} {props.refreshRate}{" "}
        {tg("global.time.days")}
      </h2>
      <h2 className={classes.noSpace}>
        {" "}
        {tg("objectives.card.maxScans")} {props.maxScans}
      </h2>
      <h2 className={classes.noSpace}>
        {" "}
        {tg("objectives.card.coolDownTime")} {props.coolDownTime / 3600}h
      </h2>
      <h2 className={classes.noSpace}>
        {tg("objectives.card.lat")}
        {props.coordinates && props.coordinates.lat !== undefined
          ? props.coordinates.lat
          : "N/A"}
        <br />
        {tg("objectives.card.lng")}
        {props.coordinates && props.coordinates.lng !== undefined
          ? props.coordinates.lng
          : "N/A"}
      </h2>
      <h2 className={classes.noSpace}>
        {tg("objectives.card.radius")} {props.radius}m
      </h2>
      <h2 className={classes.noSpace}>
        {tg("objectives.card.hideOnMobile")} {props.hideOnMobile ?? "visible"}
      </h2>
      <h2 className={classes.description}>
        {tg("objectives.card.description")} {props.description}
      </h2>     

      <div
        className={classes.buttons}
        style={{ display: "flex", alignItems: "center" }}
      >
        <button className={classes.edit} onClick={editButton}>
          <FaEdit size={40} color="black" />
          {/* <MaterialIcon icon="edit" size={40} color="White" /> */}
        </button>
        <DeleteObjective id={props.id}/>{" "}
        <button className={classes.addNew} onClick={() => setShowqr()}>
          Ver códigoQR
        </button>
        <button
          className={classes.addNew}
          onClick={() => downloadQRCode(`${props.qrID}`)}
        >
          Download QR code
        </button>
      </div>
      <div className={classes.qr}>
        <QRCode
          id={`${props.qrID}`}
          value={props.qrID}
          logoImage={GreenBearLogo}
          removeQrCodeBehindLogo={true}
          size={600}
          qrStyle={"dots"}
          logoPaddingStyle={"circle"}
          logoPadding={10}
          fgColor={"#067451"}
          logoWidth={75}
        />
      </div>


      {showQR && (
        <ShowQR id={props.id} qrID={props.qrID} ok={backdropHandlerCancel} />
      )}
      {/* prizeform always true, then prizeform handler renders it or not */}
      {showQR ? <Backdrop cancel={backdropHandlerCancel} /> : null}

      <h6 className={classes.dueDate}>
        {tg("objectives.card.valid_until")} {props.dueDate}
      </h6>
    </div>
  );
}

export function ShowQR(props) {
  return (
    <div className={classes.box}>
      <div className={classes.qr}>
        <QRCode
          id={`qrCode${props.id}`}
          value={props.qrID}
          logoImage={GreenBearLogo}
          removeQrCodeBehindLogo={true}
          size={600}
          qrStyle={"dots"}
          logoPaddingStyle={"circle"}
          logoPadding={10}
          fgColor={"#067451"}
          logoWidth={75}
        />
      </div>
      <button className={classes.cancel_button} onClick={props.ok}>
        Cancel
      </button>
    </div>
  );
}

/*    <div className={classes.qr} style={{width:'50px', height:'50px'}}>
        <QRCode
          id={`qrCode${props.id}`}
          value={props.qrID}
          logoImage={GreenBearLogo}
          removeQrCodeBehindLogo={true}
          size={600}
          qrStyle={"dots"}
          logoPaddingStyle={"circle"}
          logoPadding={10}
          fgColor={"#067451"}
          logoWidth={75}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      */
